import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { FileUploadTable } from './interfaces/file-upload-interfaces';
import {
  addressFileUploadStatusDisplayedColumns,
  currencyValues,
  lineQuantityMisurements,
  fileUploadStatusDisplayedColumns,
  fileUploadTypeCodeDisplayedColumns,
  typeCode,
  exportReasonValues,
  lineItemRefs,
  countryReference,
} from '../../../utils/constants/strings';
import { ShipmentUploadService } from './services/shipment-upload.service';
import { Subscription } from 'rxjs';
import { dateMapBetweenDays } from '../../../utils/utils';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ShipmentUploadValidationShowComponent } from './shipment-upload-validation-show/shipment-upload-validation-show.component';
import { convertFileUpload } from './file-upload-convertor';
import { BehaviourService } from '../../../shared/services/behaviour.service';
import { MatTabGroup } from '@angular/material/tabs';
import { shipmentUploadType } from 'src/app/utils/constants/constant';
import { MawbService } from '../../../shared/services/mawb.service';
import { LabelViewComponent } from '../../../shared/label-view/label-view.component';
import { MatDialog } from '@angular/material/dialog';
import { InvoiceColumns } from './invoice-enum';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { ShipmentService } from 'src/app/shared/services/shipment.service';

@Component({
  selector: 'app-shipment-upload-status',
  templateUrl: './shipment-upload-status.component.html',
  styleUrls: ['./shipment-upload-status.component.scss'],
})
export class ShipmentUploadStatusComponent implements OnInit, AfterViewInit, OnDestroy {
  fileUploadDataSource = new MatTableDataSource<FileUploadTable>();
  displayedColumns = fileUploadStatusDisplayedColumns;
  displayedTypeCodeColumns = fileUploadTypeCodeDisplayedColumns;
  addressDisplayedColumns = addressFileUploadStatusDisplayedColumns;
  displayedInvoiceColumns = [];
  displayedAddressColumns = [];
  invoiceFormKeys = [];
  invoiceColumnsReduce = InvoiceColumns;
  serviceSubscription$ = new Subscription();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChildren('tableRow', { read: ViewContainerRef }) rowContainers;
  expandedRow: number = undefined;
  fileUploadResponse = [];
  invoiceUploadedData: any = {};
  currencyCodes = [];
  headerInvoice: {
    fileName?: string;
    addedBy?: string;
    addedDateTime?: string;
  } = {};
  headerAddress: {
    fileName?: string;
    addedBy?: string;
    addedDateTime?: string;
  };
  @Input() isUploadStatus: string = '';
  @Input() mawbNumber: string = '';
  @Input() ShipmentIdNumber: string = '';
  @Input() motherStatus: string = '';
  selectedTabForUploadType: number = 0;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  invoiceForm: FormGroup[] = [];
  decimalValue: number;
  totalGrossWeight = 0;
  totalNetWeight = 0;
  totalLineItemValue = 0;
  totalLineItemQuantity = 1;
  isCurrenciesMatched: boolean;

  constructor(
    private shipmentUploadService: ShipmentUploadService,
    private mawbService: MawbService,
    private behaviourService: BehaviourService,
    private changeDetectorRef: ChangeDetectorRef,
    private resolver: ComponentFactoryResolver,
    private matDialog: MatDialog,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private configService: ConfigService,
    private errorDialogService: ErrorDialogService,
    private shipmentService: ShipmentService
  ) {
    this.getDecimalUnitPrice();
  }

  updateTheFileList() {
    this.serviceSubscription$.add(
      this.behaviourService.currentMessage.subscribe(message => {
        if (message === 'lineItemsEvent' || message === 'documentTypeEvent') {
          this.getUpdateInformationOnLoad();
        }
      })
    );
  }

  ngOnInit(): void {
    this.getUpdateInformationOnLoad();
    this.updateTheFileList();
    this.setDisplayColumns();
    this.initialiseInvoiceForm();
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    this.initialiseInvoiceForm();
    this.checkFormGroupArrayValidity();
  }

  initialiseInvoiceForm() {
    this.currencyCodes = currencyValues;
    this.invoiceForm = [];
    this.fileUploadResponse.forEach((data: any) => {
      const lineItemGroup: FormGroup = this.createLineItemGroup();
      const updatedLineItemGroup: FormGroup = this.removeControls(
        lineItemGroup,
        this.displayedInvoiceColumns
      );
      updatedLineItemGroup.patchValue(data);
      this.invoiceForm.push(updatedLineItemGroup);
      this.isCurrencyMatched();
      this.setTotalValue('lineItemGrossWeight');
      this.setTotalValue('lineItemNetWeight');
      this.setTotalValue('lineItemQuantity');
    });
    this.invoiceFormKeys = this.getFormGroupKeys();
  }

  getinputId(cid, rid) {
    return cid + rid;
  }

  removeControls(lineItemGroup, controlNames: string[]) {
    Object.keys(lineItemGroup.controls).forEach(key => {
      if (!controlNames.includes(key)) {
        lineItemGroup.removeControl(key);
      }
    });
    return lineItemGroup;
  }

  showValidationErrors(control, name) {
    const formControlErrors = control.errors;
    if (formControlErrors) {
      let errorMessages = '';
      Object.keys(formControlErrors).forEach(key => {
        switch (key) {
          case 'maxlength':
            errorMessages += `Max length should be ${formControlErrors?.maxlength.requiredLength}.`;
            break;
          case 'minlength':
            errorMessages += `Minimum length should be ${formControlErrors?.minlength.requiredLength}.`;
            break;
          case 'min':
            errorMessages += `Minimum Value should be ${formControlErrors?.min?.min}.`;
            break;
          case 'required':
            errorMessages += ' Filed is required.';
            break;
          case 'dropDownNotMatchedError':
            errorMessages += `${formControlErrors?.dropDownNotMatchedError}`;
            break;
          case 'pattern':
            if (formControlErrors?.pattern.requiredPattern === '^[0-9]*$') {
              errorMessages += 'Enter Numbers only.';
            } else if (
              formControlErrors?.pattern.requiredPattern ===
              `^[0-9]+(.[0-9]{0,${this.decimalValue}})?$`
            ) {
              errorMessages += `Allowed Decimal Value upto  ${this.decimalValue}`;
            }
            break;
        }
      });
      return errorMessages;
    }

    if (name === 'lineItemUnitPriceCurrency') {
      control.setValue(control.value.toUpperCase().trim());
      this.setControlError(this.currencyCodes, control, 'Currency');
    }
    if (name === 'lineItemQuantityUnitofMeasurement') {
      control.setValue(control.value.trim());
      this.setControlError(lineQuantityMisurements, control, 'Unit Of Measurement');
    }
    if (name === 'lineItemExportReasonType') {
      control.setValue(control.value.toLowerCase().trim());
      this.setControlError(exportReasonValues, control, 'Export Reason Type');
    }
    if (name === 'lineItemReference') {
      control.setValue(control.value.toUpperCase().trim());
      this.setControlError(lineItemRefs, control, 'Line Item Reference');
    }
    if (name === 'lineItemManufactureCountry') {
      control.setValue(control.value.toUpperCase().trim());
      const countryList = countryReference.map(obj => obj.code);
      this.setControlError(countryList, control, 'Country');
    }
  }

  setControlError(arrayList, control, field) {
    if (arrayList.includes(control.value)) {
      control.setErrors(null);
    } else {
      control.setErrors({ dropDownNotMatchedError: 'Please enter Valid ' + field });
    }
  }

  getFormGroupKeys() {
    return this.invoiceForm.map(control => Object.keys((control as FormGroup).controls));
  }
  createLineItemGroup() {
    return this.formBuilder.group({
      invoiceNumber: new FormControl(Validators.compose([Validators.maxLength(45)])),
      invoiceDate: new FormControl(Validators.maxLength(45)),
      invoiceExportReason: new FormControl('', Validators.compose([Validators.maxLength(30)])),
      invoiceIncoterm: new FormControl(''),
      invoiceUnitOfMeasurement: new FormControl(''),
      placeOfIncoterm: new FormControl(Validators.maxLength(45)),
      noOfLineItem: new FormControl(
        1,
        Validators.compose([Validators.min(1), Validators.max(999)])
      ),
      lineItemNumber: new FormControl(
        { value: '', disabled: true },
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          Validators.min(1),
          Validators.max(999),
        ])
      ),
      lineItemDescription: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(170),
        ])
      ),
      lineItemUnitPrice: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.min(0.00001),
          Validators.max(1000000000000000000),
          Validators.pattern(`^[0-9]+(.[0-9]{0,${this.decimalValue}})?$`),
        ])
      ),
      lineItemUnitPriceCurrency: new FormControl(
        { value: '', disabled: true },
        Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(3)])
      ),
      lineItemQuantity: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(1000000000),
          Validators.pattern('^[0-9]*$'),
        ])
      ),
      lineItemQuantityUnitofMeasurement: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),

      lineItemPartNumber: new FormControl(''),
      lineItemReference: new FormControl(''),
      lineItemExportCommodityCode: new FormControl(Validators.maxLength(45)),
      lineItemImportCommodityCode: new FormControl(Validators.maxLength(45)),
      lineItemExportReasonType: new FormControl('', Validators.compose([Validators.required])),
      lineItemManufactureCountry: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(2)])
      ),
      lineItemNetWeight: new FormControl(
        0.1,
        Validators.compose([
          Validators.required,
          Validators.min(0.001),
          Validators.max(999999999999),
          Validators.pattern('^[0-9]+(.[0-9]{0,3})?$'),
        ])
      ),
      lineItemGrossWeight: new FormControl(
        0.1,
        Validators.compose([
          Validators.required,
          Validators.min(0.001),
          Validators.max(999999999999),
          Validators.pattern('^[0-9]+(.[0-9]{0,3})?$'),
        ])
      ),
    });
  }

  setDisplayColumns() {
    if (this.isUploadStatus === 'address') {
      this.displayedColumns = this.addressDisplayedColumns;
    }
  }

  getUpdateInformationOnLoad() {
    const uploadTypeConfigs = {
      typeCode: () =>
        this.mawbNumber
          ? this.getMawbDetails(this.mawbNumber, 'typeCode')
          : this.getShipmentIdDetails(this.ShipmentIdNumber, 'typeCode'),
      invoice: () => this.getMawbDetails(this.mawbNumber, 'invoice'),
      default: () => {
        this.getFileShipmentStatus();
      },
    };
    return (uploadTypeConfigs[this.isUploadStatus] || uploadTypeConfigs.default)();
  }

  ngOnDestroy(): void {
    this.serviceSubscription$.unsubscribe();
  }

  onUploadTabChange(event) {
    this.selectedTabForUploadType = event.index;
    this.updateTheFileList();
    this.getUploadType(this.selectedTabForUploadType);
    this.assignFileUploadDataSource(
      this.sortData(this.fileUploadResponse),
      this.selectedTabForUploadType
    );
  }

  getDecimalUnitPrice() {
    this.configService.fetchConfig('unitPriceDecimalPoints').then(response => {
      this.decimalValue = parseInt(response.data[0].unitPriceDecimalPoints);
    });
  }

  isTabExist(tabType) {
    return (
      this.filterChangeBasedOnTab(
        this.sortData(this.fileUploadResponse),
        this.getUploadType(tabType)
      ).length > 0
    );
  }

  filterChangeBasedOnTab(response, currentTab) {
    return response.filter(
      item => item?.file_uploadsource?.toLowerCase().indexOf(currentTab.toLowerCase()) > -1
    );
  }

  filterChangeBasedOnAddressTab(response, currentTab) {
    return response.filter(
      item => item?.file_uploadsource?.toLowerCase().indexOf(currentTab.toLowerCase()) > -1
    );
  }

  getUploadType(currentTab: number) {
    const shipmentUploadTypeConfigs = {
      0: () => shipmentUploadType.MANUAL,
      1: () => shipmentUploadType.AUTOMATED,
      default: () => ``,
    };
    return (shipmentUploadTypeConfigs[currentTab] || shipmentUploadTypeConfigs.default)();
  }

  getFileShipmentStatus() {
    const { fromDate, toDate } = dateMapBetweenDays(7);
    this.serviceSubscription$.add(
      this.shipmentUploadService.shipmentUploadFileStatus(fromDate, toDate).subscribe(response => {
        this.fileUploadResponse = convertFileUpload(response);
        this.defaultTabSelection(this.sortData(this.fileUploadResponse));
      })
    );
  }

  getMawbDetails(mawb, uploadType) {
    const requestBody = { mawb: [mawb] };
    this.mawbService.getMawbUploadList(requestBody).subscribe((response: any) => {
      this.fileUploadResponse =
        uploadType === 'typeCode'
          ? response?.data[0]?.commercial_invoice_files
          : response?.data[0]?.commercial_invoice_MappedData[0]?.file;
      if (uploadType === 'invoice') {
        this.invoiceUploadedData = response;
        this.invoiceDataAssign(response);
      } else {
        this.assignFileUploadDataSource(this.sortData(this.fileUploadResponse, 'addedDateTime'));
      }
    });
  }

  invoiceDataAssign(response) {
    this.headerInvoice = response.data[0]?.commercial_invoice_MappedData[0];
    this.displayedInvoiceColumns = Object.keys(this.fileUploadResponse[0]);
    this.initialiseInvoiceForm();
  }

  defaultTabSelection(response) {
    if (this.isTabExist(0)) {
      this.assignFileUploadDataSource(response, 0);
    }
    if (!this.isTabExist(0) && this.isTabExist(1)) {
      this.assignFileUploadDataSource(response, 1);
    }
  }

  assignFileUploadDataSource(response, filterTab = 0) {
    this.fileUploadDataSource.data = this.getFileUploadType(filterTab);
    this.changeDetectorRef.detectChanges();
    this.fileUploadDataSource.paginator = this.paginator;
    this.fileUploadDataSource.sort = this.sort;
  }

  sortData(items, key = 'upload_datetime') {
    if (key === 'addedDateTime') {
      return items.sort((a, b) => {
        return <any>new Date(b.addedDateTime) - <any>new Date(a.addedDateTime);
      });
    } else {
      return items.sort((a, b) => {
        return <any>new Date(b.upload_datetime) - <any>new Date(a.upload_datetime);
      });
    }
  }

  setTotalValue(property) {
    switch (property) {
      case 'lineItemGrossWeight':
        this.totalGrossWeight = Math.round(this.sumPropertyValues(property) * 10000) / 10000;
        break;
      case 'lineItemNetWeight':
        this.totalNetWeight = Math.round(this.sumPropertyValues(property) * 10000) / 10000;
        break;
      case 'lineItemQuantity':
        this.totalLineItemQuantity = Math.round(this.sumPropertyValues(property) * 10000) / 10000;
        this.setTotalLineItemValue();
        break;
      case 'lineItemUnitPrice':
        this.setTotalLineItemValue();
        break;
    }
  }

  setTotalLineItemValue() {
    this.totalLineItemValue = 0;
    const lineItemsArray = this.invoiceForm;
    if (lineItemsArray.length > 0) {
      lineItemsArray.forEach((lineItem: FormGroup) => {
        this.totalLineItemValue =
          this.totalLineItemValue +
          Number(lineItem.value?.lineItemQuantity) * Number(lineItem.value?.lineItemUnitPrice);
        this.totalLineItemValue = Math.round(this.totalLineItemValue * 100) / 100;
      });
    }
  }

  setCurrency(event) {
    this.invoiceForm.forEach(formGroup => {
      formGroup.get('lineItemUnitPriceCurrency').setErrors(null);
      this.isCurrenciesMatched = true;
      formGroup.patchValue({
        lineItemUnitPriceCurrency: event.target.value,
      });
    });
  }

  sumPropertyValues(property) {
    const invoiceItemsList = this.getinvoiceFormGroupValues();
    return invoiceItemsList.reduce(
      (accumulator, currentValue) => accumulator + Number(currentValue[property]),
      0
    );
  }

  checkFormGroupArrayValidity() {
    let isFormValid = true;
    this.invoiceForm.forEach(formGroup => {
      if (!formGroup.valid === true) {
        return (isFormValid = false);
      }
    });
    return isFormValid && this.isCurrenciesMatched;
  }

  isCurrencyMatched() {
    const firstValue = this.fileUploadResponse[0]?.lineItemUnitPriceCurrency;
    if (firstValue) {
      this.isCurrenciesMatched = this.fileUploadResponse.every(
        obj => obj['lineItemUnitPriceCurrency'] === firstValue
      );
    } else {
      this.isCurrenciesMatched = true;
    }
  }

  getinvoiceFormGroupValues(): any {
    const lineItemList = [];
    this.invoiceForm.forEach(group => {
      lineItemList.push(group.getRawValue());
    });

    return lineItemList;
  }

  getFileUploadType(currentTab: number) {
    const uploadTypeConfigs = {
      typeCode: () => (this.fileUploadResponse = this.sortData(this.fileUploadResponse)),
      invoice: () => (this.fileUploadResponse = this.sortData(this.fileUploadResponse)),
      address: () =>
        this.filterChangeBasedOnAddressTab(this.sortData(this.fileUploadResponse), 'ADDRESS'),
      default: () =>
        this.filterChangeBasedOnTab(
          this.sortData(this.fileUploadResponse),
          this.getUploadType(currentTab)
        ),
    };
    return (uploadTypeConfigs[this.isUploadStatus] || uploadTypeConfigs.default)();
  }

  insertComponent(index: number, _id) {
    if (this.expandedRow != null) {
      this.rowContainers.toArray()[this.expandedRow].clear();
    }
    if (this.expandedRow === index) {
      this.expandedRow = null;
    } else {
      const container = this.rowContainers.toArray()[index];
      const factory: ComponentFactory<any> = this.resolver.resolveComponentFactory(
        ShipmentUploadValidationShowComponent
      );
      const inlineComponent = container.createComponent(factory);
      inlineComponent.instance.type = this.isUploadStatus;
      if (this.isUploadStatus === 'address') {
        inlineComponent.instance.fileErrors = this.fileUploadResponse.find(
          item => item?.file_id === _id
        ).errors_list;
      } else {
        inlineComponent.instance.fileErrors = this.fileUploadResponse.find(
          item => item?._id === _id
        ).errors_list;
      }
      this.expandedRow = index;
    }
  }

  getTypeCodeValue(code) {
    return typeCode.find(item => item.code === code)?.value;
  }

  viewUploadedCI(content, format, typeCode) {
    this.openView(content, format, this.getTypeCodeValue(typeCode));
  }

  openView(base64Encode, format, typeCode) {
    const dialogRef = this.matDialog.open(LabelViewComponent, {
      data: {
        label: base64Encode,
        labelName: typeCode,
        format: format.toLowerCase(),
      },
      maxHeight: '90vh',
      maxWidth: '50vw',
    });
    dialogRef.afterClosed().subscribe(() => ``);
  }

  deleteUploadedCI(uploadCI, uploadType) {
    const requestBody = {
      body: {
        _id: [uploadCI],
      },
    };
    this.serviceSubscription$.add(
      this.mawbNumber
        ? this.mawbService.deleteUploadCI(requestBody).subscribe(() => {
            if (this.mawbNumber) {
              this.getMawbDetails(this.mawbNumber, uploadType);
            } else if (this.ShipmentIdNumber) {
              this.getShipmentIdDetails(this.ShipmentIdNumber, uploadType);
            }
          })
        : this.shipmentService.deleteUploadCI(requestBody).subscribe(() => {
            if (this.mawbNumber) {
              this.getMawbDetails(this.mawbNumber, uploadType);
            } else if (this.ShipmentIdNumber) {
              this.getShipmentIdDetails(this.ShipmentIdNumber, uploadType);
            }
          })
    );
  }

  saveInvoiceUploadData() {
    const invoiceItemsList = this.getinvoiceFormGroupValues();
    this.invoiceUploadedData.data[0].commercial_invoice_MappedData[0].file = invoiceItemsList;
    this.invoiceUploadedData.data[0].Errors = [];
    this.invoiceUploadedData.data[0].validationFailed = false;
    this.mawbService.saveInvoiceUploadData(this.invoiceUploadedData.data[0]).subscribe(() => {
      this.errorDialogService.openDialog('alert.invoiceUpdateSuccess', false);
    });
  }

  getShipmentIdDetails(shipmentID, uploadType) {
    const requestBody = { shipmentID: [shipmentID] };
    this.shipmentService.getShipmentUploadList(requestBody).subscribe((response: any) => {
      this.fileUploadResponse =
        uploadType === 'typeCode'
          ? response?.data[0]?.commercial_invoice_files
          : response?.data[0]?.commercial_invoice_MappedData[0]?.file;
      this.assignFileUploadDataSource(this.sortData(this.fileUploadResponse, 'addedDateTime'));
    });
  }
}
